import { Switch } from '@sara/ui/components/switch';
import { Label } from '@sara/ui/components/label';
import type { FilterEditorProps } from '../types';

export function CompletedNoResultsEditor({ search, onChange }: FilterEditorProps) {
  const checked = search.completedNoResults === true;

  function handleCheckedChange(next: boolean) {
    onChange({ completedNoResults: next ? true : undefined });
  }

  return (
    <div className="flex items-center gap-2">
      <Switch
        id="completed-no-results-toggle"
        checked={checked}
        onCheckedChange={handleCheckedChange}
      />
      <Label htmlFor="completed-no-results-toggle" className="text-[13.5px] font-normal">
        Completed, no results
      </Label>
    </div>
  );
}
